import Cheeseburger from "../assets/cheeseburger.jpg";
import DoubleCheeseburger from "../assets/doubledoublecheeseburger.jpg";
import ButtermilkChicken from "../assets/buttermilkchicken.jpg";
import ChickenStrips from "../assets/chickenstrips.jpg";
import Pizza from "../assets/pizza.jpg";
import SimpleGreenSalad from "../assets/simplegreensalad.jpg";
import PotluckChoppedSalad from "../assets/potluckchoppedsalad.jpg";
import CrispFluffyWaffles from "../assets/crispfluffywaffles.jpg";
import UltimatePancakes from "../assets/ultimatepancakes.jpg";
import EggsHashbrownBacon from "../assets/eggshashbrownbacon.jpg";
import ApplePie from "../assets/applepie.jpg";
import Milkshakes from "../assets/milkshakes.jpg";

export const Data = [
{
name: "Cheeseburger",
image: Cheeseburger,
price: 14,
},
{
name: "Double Double Cheeseburger",
image: DoubleCheeseburger,
price: 18,
},
{
name: "Buttermilk Fried Chicken Burger",
image: ButtermilkChicken,
price: 15,
},
{
name: "Chicken Strips",
image: ChickenStrips,
price: 14,
},
{
    name: "Pizza Slice",
    image: Pizza,
    price: 13,
},
{
name: "Simple Green Salad",
image: SimpleGreenSalad,
price: 10,
},
{
    name: "Potluck Chopped Salad",
    image: PotluckChoppedSalad,
    price: 11,
},
{
    name: "Crisp and Fluffy Waffles",
    image: CrispFluffyWaffles,
    price: 14,
},
{
    name: "Ultimate Pancakes",
    image: UltimatePancakes,
    price: 15,
},
{
    name: "Eggs, Hashbrown and Bacon",
    image: EggsHashbrownBacon,
    price: 13,
},
{
    name: "Apple Pie",
    image: ApplePie,
    price: 7,
},
{
    name: "Milkshake",
    image: Milkshakes,
    price: 6,
}
]